<div class="matTabGroupContainer">
  <form class="example-form" #updateForm="ngForm">
    <mat-tab-group class="absoluteFill" fxFlexFill *ngIf="!!dataDetail" [(selectedIndex)]="tabIndex"
                   (selectedTabChange)="tabChanges($event)">
      <mat-tab label="{{ 'PRODUCTITEM.TABS.DETAILS' | translate}}">

        <div fxFlex="100%" fxLayout="column" style="margin-bottom: 15px;">

          <div fxLayout="row" fxLayoutGap="10px">
            <!--  ************************************  -->
            <!--              PRODUCTITEM NAME               -->
            <!--  ************************************  -->
            <mat-form-field fxFlex class="fullWidthField ">
              <mat-label>{{'PRODUCTITEM.NAME' | translate}}</mat-label>
              <input matInput required #productItemName="ngModel" type="text" name="productItemName" [disabled]="!editMode"
                     [(ngModel)]="dataDetail.name">
              <mat-error *ngIf="productItemName.invalid">
                {{'PRODUCTITEM.NAME_FIELD' | translate}} <strong>{{'COMMON.IS_REQUIRED' | translate}}</strong>
              </mat-error>
            </mat-form-field>

            <!--  ************************************  -->
            <!--              PRODUCTITEM LABEL              -->
            <!--  ************************************  -->
            <mat-form-field fxFlex class="fullWidthField ">
              <mat-label>{{'PRODUCTITEM.LABEL' | translate}}</mat-label>
              <input matInput required #productItemLabel="ngModel" type="text" name="productItemLabel" [disabled]="!editMode"
                     [(ngModel)]="dataDetail.label">
              <mat-error *ngIf="productItemLabel.invalid">
                {{'PRODUCTITEM.LABEL_FIELD' | translate}} <strong>{{'COMMON.IS_REQUIRED' | translate}}</strong>
              </mat-error>
            </mat-form-field>
          </div>

          <div fxLayout="row" fxLayoutGap="10px">
            <!--  ************************************  -->
            <!--          PRODUCTITEM PRODUCT_TYPE           -->
            <!--  ************************************  -->

            <mat-form-field fxFlex class="fullWidthField" style="line-height: 18px;">
              <mat-label>{{'PRODUCTITEM.PRODUCT_TYPE' | translate}}</mat-label>
              <mat-select class="mat-typography" name="parentCustomerId" [(ngModel)]="dataDetail.productType"
                          [disabled]="true"
                          #productItemProductType="ngModel" required="">
                <mat-option [value]="dataDetail.productType"><span class="mat-typography">{{dataDetail.productType.name}}</span></mat-option>
              </mat-select>
              <mat-error *ngIf="productItemProductType.invalid">
                {{'PRODUCTITEM.PRODUCT_TYPE_FIELD' | translate}} <strong>{{'COMMON.IS_REQUIRED' | translate}}</strong>
              </mat-error>
            </mat-form-field>

            <!--  ************************************  -->
            <!--            PRODUCTITEM SERIAL #             -->
            <!--  ************************************  -->
            <mat-form-field fxFlex class="fullWidthField ">
              <mat-label>{{'PRODUCTITEM.SERIAL_NUMBER' | translate}}</mat-label>
              <input matInput required #productItemSerialNumber="ngModel" type="text" name="productItemSerialNumber"
                     [disabled]="!editMode"
                     [(ngModel)]="dataDetail.serialNumber">
              <mat-error *ngIf="productItemSerialNumber.invalid">
                {{'PRODUCTITEM.SERIAL_NUMBER_FIELD' | translate}} <strong>{{'COMMON.IS_REQUIRED' | translate}}</strong>
              </mat-error>
            </mat-form-field>
          </div>

          <div fxLayout="row" fxLayoutGap="10px">
            <!--  ************************************  -->
            <!--             PRODUCTITEM LATITUDE            -->
            <!--  ************************************  -->

            <mat-form-field fxFlex class="fullWidthField">
              <mat-label>{{'PRODUCTITEM.LATITUDE' | translate}}</mat-label>
              <input matInput [required]="!dataDetail.productType.moving" #productItemLatitude="ngModel" type="number" name="productItemLatitude"
                     [disabled]="!editMode || dataDetail.productType.moving"
                     [(ngModel)]="dataDetail.latitude">
              <mat-error *ngIf="productItemLatitude.invalid">
                {{'PRODUCTITEM.LATITUDE_FIELD' | translate}} <strong>{{'COMMON.IS_REQUIRED' | translate}}</strong>
              </mat-error>
            </mat-form-field>

            <!--  ************************************  -->
            <!--            PRODUCTITEM LONGITUDE            -->
            <!--  ************************************  -->
            <mat-form-field fxFlex class="fullWidthField ">
              <mat-label>{{'PRODUCTITEM.LONGITUDE' | translate}}</mat-label>
              <input matInput [required]="!dataDetail.productType.moving" #productItemLongitude="ngModel" type="number" name="productItemLongitude"
                     [disabled]="!editMode || dataDetail.productType.moving"
                     [(ngModel)]="dataDetail.longitude">
              <mat-error *ngIf="productItemLongitude.invalid">
                {{'PRODUCTITEM.LONGITUDE_FIELD' | translate}} <strong>{{'COMMON.IS_REQUIRED' | translate}}</strong>
              </mat-error>
            </mat-form-field>
          </div>


          <div fxLayout="row" fxLayoutGap="10px">
            <!--  ************************************  -->
            <!--             PRODUCTITEM LOCATION            -->
            <!--  ************************************  -->

            <mat-form-field fxFlex class="fullWidthField">
              <mat-label>{{'PRODUCTITEM.LOCATION' | translate}}</mat-label>
              <input matInput required #productItemLocation="ngModel" type="text" name="productItemLocation"
                     [disabled]="!editMode"
                     [(ngModel)]="dataDetail.location">
              <mat-error *ngIf="productItemLocation.invalid">
                {{'PRODUCTITEM.LOCATION_FIELD' | translate}} <strong>{{'COMMON.IS_REQUIRED' | translate}}</strong>
              </mat-error>
            </mat-form-field>

            <!--  ************************************  -->
            <!--              PRODUCTITEM NOTES              -->
            <!--  ************************************  -->
            <mat-form-field fxFlex class="fullWidthField ">
              <mat-label>{{'PRODUCTITEM.NOTES' | translate}}</mat-label>
              <input matInput #productItemNotes="ngModel" type="text" name="productItemNotes" [disabled]="!editMode"
                     [(ngModel)]="dataDetail.note">
            </mat-form-field>
          </div>

          <div fxLayout="row" fxLayoutGap="10px" style="padding: 8px 0;">
            <!--  ************************************  -->
            <!--             PRODUCTITEM HAS-DAE             -->
            <!--  ************************************  -->

            <mat-slide-toggle color="primary" name="productItemHasDae" [disabled]="!editMode"
                              [(ngModel)]="dataDetail.hasDae" (ngModelChange)="createDAEObjects()" fxFlex>
              {{'PRODUCTITEM.HAS_DAE' | translate}}
            </mat-slide-toggle>

            <!--  ************************************  -->
            <!--              PRODUCTITEM IS-E015            -->
            <!--  ************************************  -->
            <mat-slide-toggle color="primary" name="productItemIsE015" [disabled]="!editMode"
                              [(ngModel)]="dataDetail.isE015" (ngModelChange)="createE015Objects()" fxFlex *ngIf="dataDetail.productType.monitored">
              {{'PRODUCTITEM.IS_E015' | translate}}
            </mat-slide-toggle>

          </div>

          <div *ngIf="dataDetail.productType.monitored" fxLayoutAlign="row baseline" fxLayoutGap="10px" style="padding: 8px 0; ">
            <!--  ************************************  -->
            <!--         PRODUCTITEM ON CHIRPSTACK           -->
            <!--  ************************************  -->

            <mat-slide-toggle color="primary" name="useChirpstack" [disabled]="!editMode || isOnChirpstack"
                              [(ngModel)]="dataDetail.useChirpstack" fxFlex>
              {{'PRODUCTITEM.CHIRPSTACK.CHIRPSTACK_USE' | translate}}
            </mat-slide-toggle>

            <!--  ************************************  -->
            <!--              PRODUCTITEM EUI64              -->
            <!--  ************************************  -->
            <mat-form-field fxFlex class="fullWidthField">
              <mat-label>{{'PRODUCTITEM.CHIRPSTACK.CHIRPSTACK_DEVEUI' | translate}}</mat-label>
              <input matInput required #devEui="ngModel" type="text" name="devEui"
                     [disabled]="!editMode || !dataDetail.useChirpstack || isOnChirpstack"
                     [(ngModel)]="dataDetail.devEui" [pattern]="EUIRegex" [maxlength]="23">
              <mat-error *ngIf="devEui.invalid && dataDetail.devEui === ''">
                {{'PRODUCTITEM.CHIRPSTACK.CHIRPSTACK_DEVEUI_FIELD' | translate}} <strong>{{'COMMON.IS_REQUIRED' | translate}}</strong>
              </mat-error>
              <mat-error *ngIf="devEui.dirty && dataDetail.devEui !== '' && devEui.invalid">
                {{'PRODUCTITEM.CHIRPSTACK.CHIRPSTACK_DEVEUI_FIELD' | translate}} <strong>{{'COMMON.IS_IN_WRONG_FORMAT' | translate}}</strong>
              </mat-error>
            </mat-form-field>
          </div>

          <div  style="margin: 5px 0" fxFlex fxLayoutAlign="space-between center">
            <button style="height: 40px" *ngIf="gmService.osmEnabled" [disabled]="!dataDetail.hasOsmUrl || !dataDetail.osmUrl" type="button" color="primary" mat-raised-button
                    (click)="openStreetMapUrl(dataDetail)">{{'PRODUCTITEM.SHOW_IN_OSM' | translate}}</button>
            <button *ngIf="dataDetail.productType.monitored" style="height: 40px" [disabled]="editMode || !isOnChirpstack" mat-raised-button type="button" color="primary" [title]="'PRODUCTITEM.CHIRPSTACK.CHIRPSTACK_RESET' | translate" (click)="deleteChirpstackProductItem()">{{'PRODUCTITEM.CHIRPSTACK.CHIRPSTACK_RESET' | translate}}</button>

          </div>

          <div *ngIf="editMode" style="margin: 5px 0">
            <button style="height: 40px" type="button" color="primary" mat-raised-button
                    (click)="fileInput.click()">{{'PRODUCTITEM.PICTURE' | translate}}</button>
            <input hidden (change)="onFileSelected($event)" #fileInput type="file" id="file">
            <span *ngIf="!!selectedFile"><i> {{selectedFile.name}}</i></span>
            <span
                    *ngIf="!selectedFile && !!dataDetail.imageUrl"><i> {{imageFileNameFromUrl(dataDetail.imageUrl)}}</i></span>
            <button style="margin-left: 5px" *ngIf="!!selectedFile || !!dataDetail.imageUrl" type="button" mat-mini-fab
                    color="primary"
                    (click)="resetImage()">
              <mat-icon>close</mat-icon>
            </button>
          </div>

          <p *ngIf="!editMode && !!dataDetail.imageUrl" style="margin-top: 10px;">{{'PRODUCTITEM.PICTURE' | translate}}</p>

          <img style="max-width: 250px" *ngIf="!editMode && !!dataDetail.imageUrl" [src]="dataDetail.imageUrl"
               [alt]="dataDetail.name">

        </div>

      </mat-tab>

      <mat-tab label="{{ 'PRODUCTITEM.TABS.CHARGERS' | translate}}">
        <table style="padding: 0 !important;"  mat-table [dataSource]="tableDataSource" aria-describedby="product_Types">

          <!-- Product_Type email Column -->
          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef width="40%"> Nome </th>
            <td mat-cell *matCellDef="let element">
              <span [class]="getConnectorClass(element)">{{element.chargerType.name}}</span>
            </td>
          </ng-container>

          <!-- Product_Type email Column -->
          <ng-container matColumnDef="power">
            <th mat-header-cell *matHeaderCellDef width="20%">Potenza</th>
            <td mat-cell *matCellDef="let element">
              <span [class]="getConnectorClass(element)">{{element.chargerType.wattPower}} W</span>
            </td>
          </ng-container>

          <!-- Product_Type firstname Column -->
          <ng-container matColumnDef="taIndex">
            <th mat-header-cell *matHeaderCellDef width="10%">Ta Index</th>
            <td mat-cell *matCellDef="let element">
              <input style="width: 5ch !important;" matInput type="number" name="index{{element.chargerType.id}}" [disabled]="element.chargerCount < 1 || !editMode" [(ngModel)]="element.taIndex" min="0" required step="1">
            </td>
          </ng-container>

          <!-- Product_Type lastname Column -->
          <ng-container matColumnDef="count">
            <th mat-header-cell *matHeaderCellDef width="10%">Qtà</th>
            <td mat-cell *matCellDef="let element">
              <input style="width: 5ch !important;" matInput type="number" name="count{{element.chargerType.id}}" [(ngModel)]="element.chargerCount" [disabled]="!editMode"  min="0" max="99" required step="1">
            </td>

          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

          <!--  ************************************  -->
          <!--               NO DATA ROW              -->
          <!--  ************************************  -->
          <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell" [colSpan]="displayedColumns.length">{{'COMMON.NO_DATA_FOUND' | translate }}</td>
          </tr>
        </table>
      </mat-tab>
      <mat-tab label="{{ 'PRODUCTITEM.TABS.DAE' | translate}}" [disabled]="!dataDetail.hasDae">

        <div fxFlex="100%" fxLayout="column" *ngIf="!!dataDetail.daeAttributes">

          <div fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="space-around center">
            <!--  ************************************  -->
            <!--            DAE IS MONITORED            -->
            <!--  ************************************  -->

            <mat-slide-toggle color="primary" name="daeIsMonitored" [disabled]="!editMode || !dataDetail.productType.monitored"
                              [(ngModel)]="dataDetail.daeAttributes.daeIsMonitored" fxFlex>
              {{'PRODUCTITEM.DAE_IS_MONITORED' | translate}}
            </mat-slide-toggle>

            <!--  ************************************  -->
            <!--            DAE SERIAL NUMBER           -->
            <!--  ************************************  -->

            <mat-form-field fxFlex class="fullWidthField">
              <mat-label>{{'PRODUCTITEM.DAE_SERIAL_NUMBER' | translate}}</mat-label>
              <input matInput #productItemDaeSerialNumber="ngModel" type="text" name="productItemDaeSerialNumber" [required]="false" [disabled]="!editMode"
                     [(ngModel)]="dataDetail.daeAttributes.daeSerialNumber">
              <!--              <mat-error *ngIf="productItemDaeSerialNumber.invalid">-->
              <!--                {{'PRODUCTITEM.DAE_SERIAL_NUMBER_FIELD' | translate}} <strong>{{'COMMON.IS_REQUIRED' | translate}}</strong>-->
              <!--              </mat-error>-->
            </mat-form-field>

          </div>

          <div fxLayout="row" fxLayoutGap="10px">
            <!--  ************************************  -->
            <!--           DAE BATTERY EXPIRE           -->
            <!--  ************************************  -->

            <mat-form-field fxFlex>
              <mat-label>{{'PRODUCTITEM.DAE_BATTERY_EXPIRE_DATE' | translate }}</mat-label>
              <input matInput #batteryExp="ngModel" name="expireBatteryDate" [disabled]="!editMode"
                     [ngModel]="expireBatteryDate" [matDatepicker]="batDate"
                     (ngModelChange)="assignBattExpDate($event)">
              <mat-datepicker-toggle matSuffix [for]="batDate"></mat-datepicker-toggle>
              <mat-datepicker #batDate></mat-datepicker>
            </mat-form-field>


            <!--  ************************************  -->
            <!--           DAE BATTERY EXPIRE           -->
            <!--  ************************************  -->

            <mat-form-field fxFlex>
              <mat-label>{{'PRODUCTITEM.DAE_ELECTRODE_EXPIRE_DATE' | translate }}</mat-label>
              <input matInput #electrodeExp="ngModel" name="expireElectrodeDate" [disabled]="!editMode"
                     [ngModel]="expireElectrodeDate" [matDatepicker]="elDate"
                     (ngModelChange)="assignElectExpDate($event)">
              <mat-datepicker-toggle matSuffix [for]="elDate"></mat-datepicker-toggle>
              <mat-datepicker #elDate></mat-datepicker>
            </mat-form-field>
          </div>


        </div>

      </mat-tab>

      <mat-tab label="{{ 'PRODUCTITEM.TABS.E015' | translate}}" [disabled]="!dataDetail.isE015" *ngIf="dataDetail.productType.monitored">


        <div fxFlex="100%" fxLayout="column" *ngIf="!!dataDetail.e015Attributes">


          <div fxLayout="row" fxLayoutGap="10px">
            <!--  ************************************  -->
            <!--             E015 PROVIDER              -->
            <!--  ************************************  -->
            <mat-form-field fxFlex class="fullWidthField ">
              <mat-label>{{'PRODUCTITEM.E015_PROVIDER' | translate}}</mat-label>
              <input matInput required #productItemE015Provider="ngModel" type="text" name="productItemE015Provider"
                     [disabled]="!editMode"
                     [(ngModel)]="dataDetail.e015Attributes.providerName">
              <mat-error *ngIf="productItemE015Provider.invalid">
                {{'PRODUCTITEM.E015_PROVIDER_FIELD' | translate}} <strong>{{'COMMON.IS_REQUIRED' | translate}}</strong>
              </mat-error>
            </mat-form-field>

            <!--  ************************************  -->
            <!--            E015 STATION ID             -->
            <!--  ************************************  -->
            <mat-form-field fxFlex class="fullWidthField ">
              <mat-label>{{'PRODUCTITEM.E015_STATION_ID' | translate}}</mat-label>
              <input matInput required #e015StationId="ngModel" type="text" name="e015StationId" [disabled]="true"
                     [(ngModel)]="dataDetail.e015Attributes.stationId">
              <mat-error *ngIf="e015StationId.invalid">
                {{'PRODUCTITEM.E015_STATION_ID_FIELD' | translate}} <strong>{{'COMMON.IS_REQUIRED' | translate}}</strong>
              </mat-error>
              <mat-hint *ngIf="dataDetail.e015Attributes.stationId !== dataDetail.name"> {{'PRODUCTITEM.E015_STATION_ID_INFO' | translate}} <strong>{{dataDetail.name}}</strong> </mat-hint>
            </mat-form-field>
          </div>

          <!--  ************************************  -->
          <!--         E015 LOCATION ADDRESS          -->
          <!--  ************************************  -->
          <div fxLayout="row">
            <mat-form-field class="fullWidthField ">
              <mat-label>{{'PRODUCTITEM.E015_LOCATION_ADDRESS' | translate}}</mat-label>
              <input matInput required #e015LocationAddress="ngModel" type="text" name="e015LocationAddress"
                     [disabled]="!editMode"
                     [(ngModel)]="dataDetail.e015Attributes.locationAddress">
              <mat-error *ngIf="e015LocationAddress.invalid">
                {{'PRODUCTITEM.E015_LOCATION_ADDRESS_FIELD' | translate}}
                <strong>{{'COMMON.IS_REQUIRED' | translate}}</strong>
              </mat-error>
            </mat-form-field>
          </div>

          <div fxLayout="row" fxLayoutGap="10px">
            <!--  ************************************  -->
            <!--       E015 LOCATION ADDRESS TYPE       -->
            <!--  ************************************  -->

            <mat-form-field fxFlex class="fullWidthField">
              <mat-label>{{'PRODUCTITEM.E015_LOCATION_ADDRESS_TYPE' | translate}}</mat-label>
              <input matInput required #e015LocationAddressType="ngModel" type="text" name="e015LocationAddressType"
                     [disabled]="!editMode"
                     [(ngModel)]="dataDetail.e015Attributes.locationAddressType">
              <mat-error *ngIf="e015LocationAddressType.invalid">
                {{'PRODUCTITEM.E015_LOCATION_ADDRESS_TYPE_FIELD' | translate}}
                <strong>{{'COMMON.IS_REQUIRED' | translate}}</strong>
              </mat-error>
            </mat-form-field>

            <!--  ************************************  -->
            <!--         E015 LOCATION ZIP CODE         -->
            <!--  ************************************  -->
            <mat-form-field fxFlex class="fullWidthField ">
              <mat-label>{{'PRODUCTITEM.E015_LOCATION_ZIP_CODE' | translate}}</mat-label>
              <input matInput required #e015LocationZipCode="ngModel" type="text" name="e015LocationZipCode"
                     [disabled]="!editMode"
                     [(ngModel)]="dataDetail.e015Attributes.locationZipCode">
              <mat-error *ngIf="e015LocationZipCode.invalid">
                {{'PRODUCTITEM.E015_LOCATION_ZIP_CODE_FIELD' | translate}}
                <strong>{{'COMMON.IS_REQUIRED' | translate}}</strong>
              </mat-error>
            </mat-form-field>
          </div>


          <div fxLayout="row" fxLayoutGap="10px">
            <!--  ************************************  -->
            <!--          E015 LOCATION CITY           -->
            <!--  ************************************  -->
            <mat-form-field fxFlex class="fullWidthField ">
              <mat-label>{{'PRODUCTITEM.E015_LOCATION_CITY' | translate}}</mat-label>
              <input matInput required #e015LocationCity="ngModel" type="text" name="e015LocationCity"
                     [disabled]="!editMode"
                     [(ngModel)]="dataDetail.e015Attributes.locationCity">
              <mat-error *ngIf="e015LocationCity.invalid">
                {{'PRODUCTITEM.E015_LOCATION_CITY_FIELD' | translate}} <strong>{{'COMMON.IS_REQUIRED' | translate}}</strong>
              </mat-error>
            </mat-form-field>

            <!--  ************************************  -->
            <!--         E015 LOCATION PROVINCE         -->
            <!--  ************************************  -->
            <mat-form-field fxFlex class="fullWidthField ">
              <mat-label>{{'PRODUCTITEM.E015_LOCATION_PROVINCE' | translate}}</mat-label>
              <input matInput required #e015LocationProvince="ngModel" type="text" name="e015LocationProvince"
                     [disabled]="!editMode"
                     [(ngModel)]="dataDetail.e015Attributes.locationProvince">
              <mat-error *ngIf="e015LocationProvince.invalid">
                {{'PRODUCTITEM.E015_LOCATION_PROVINCE_FIELD' | translate}}
                <strong>{{'COMMON.IS_REQUIRED' | translate}}</strong>
              </mat-error>
            </mat-form-field>
          </div>

          <div fxLayout="row" fxLayoutGap="10px">
            <!--  ************************************  -->
            <!--           E015 LOCATION REGION         -->
            <!--  ************************************  -->

            <mat-form-field fxFlex class="fullWidthField">
              <mat-label>{{'PRODUCTITEM.E015_LOCATION_REGION' | translate}}</mat-label>
              <input matInput required #e015LocationRegion="ngModel" type="text" name="e015LocationRegion"
                     [disabled]="!editMode"
                     [(ngModel)]="dataDetail.e015Attributes.locationRegion">
              <mat-error *ngIf="e015LocationRegion.invalid">
                {{'PRODUCTITEM.E015_LOCATION_REGION_FIELD' | translate}}
                <strong>{{'COMMON.IS_REQUIRED' | translate}}</strong>
              </mat-error>
            </mat-form-field>

            <!--  ************************************  -->
            <!--       E015 STATION ACCESSIBILITY       -->
            <!--  ************************************  -->
            <mat-form-field fxFlex class="fullWidthField ">
              <mat-label>{{'PRODUCTITEM.E015_STATION_ACCESSIBILITY' | translate}}</mat-label>
              <mat-select class="mat-typography" name="e015StationAccessibility" [(ngModel)]="dataDetail.e015Attributes.stationAccessibility"
                          [disabled]="!editMode"
                          #e015StationAccessibility="ngModel" required="">
                <mat-option *ngFor="let type of Object.values(AccessibilityTypes)" [value]="type"><span class="mat-typography">{{type}}</span></mat-option>
              </mat-select>
              <mat-error *ngIf="e015StationAccessibility.invalid">
                {{'PRODUCTITEM.E015_STATION_ACCESSIBILITY_FIELD' | translate}}
                <strong>{{'COMMON.IS_REQUIRED' | translate}}</strong>
              </mat-error>
            </mat-form-field>
          </div>

          <div fxLayout="row" fxLayoutGap="10px" style="padding: 8px 0;">
            <!--  ************************************  -->
            <!--             PRODUCTITEM HAS-DAE             -->
            <!--  ************************************  -->

            <mat-slide-toggle color="primary" name="e015AlwaysAvailable" [disabled]="!editMode"
                              [(ngModel)]="dataDetail.e015Attributes.isAlwaysAvailable" fxFlex>
              {{'PRODUCTITEM.E015_ALWAYS_AVAILABLE' | translate}}
            </mat-slide-toggle>

            <!--  ************************************  -->
            <!--         PRODUCTITEM FROM SUST. ENERGY       -->
            <!--  ************************************  -->
            <mat-slide-toggle color="primary" name="e015FromSustainableEnergy" [disabled]="!editMode"
                              [(ngModel)]="dataDetail.e015Attributes.isFromSustainableEnergy" fxFlex>
              {{'PRODUCTITEM.E015_FROM_SUSTAINABLE_ENERGY' | translate}}
            </mat-slide-toggle>

          </div>
        </div>

      </mat-tab>
    </mat-tab-group>
  </form>

</div>
